import type { PrinterApi } from "../../api/PrinterApi";
import type { CashDrawerFetchOptions } from "../../generated/dto/CashDrawerFetchOptions";
import type { CashDrawerStaff } from "../../generated/dto/CashDrawerStaff";
import type { CreatePrinterStaff } from "../../generated/dto/CreatePrinterStaff";
import type { DeletePrinterStaff } from "../../generated/dto/DeletePrinterStaff";
import type { PrinterFetchOptions } from "../../generated/dto/PrinterFetchOptions";
import type { PrinterPrintReceiptRequest } from "../../generated/dto/PrinterPrintReceiptRequest";
import type { PrinterRef } from "../../generated/dto/PrinterRef";
import type { PrinterSetCredentialsRequest } from "../../generated/dto/PrinterSetCredentialsRequest";
import type { PrinterStaff } from "../../generated/dto/PrinterStaff";
import type { PrinterStaffSearchParams } from "../../generated/dto/PrinterStaffSearchParams";
import type { PrinterStaffSearchResult } from "../../generated/dto/PrinterStaffSearchResult";
import type { UpdatePrinterStaff } from "../../generated/dto/UpdatePrinterStaff";
import type { PaginationResult } from "../../generated/dto/PaginationResult";

export class PrinterFrontendService {
  constructor(private readonly api: PrinterApi) {}
  async getPrinterStaff(id: string, options?: PrinterFetchOptions): Promise<PrinterStaff> {
    return this.api.getPrinterStaff(id, options)
  }
  async createPrinterStaff(source: CreatePrinterStaff): Promise<PrinterStaff> {
    return this.api.createPrinterStaff(source)
  }
  async updatePrinterStaff(source: UpdatePrinterStaff): Promise<PrinterStaff> {
    return this.api.updatePrinterStaff(source)
  }
  async deletePrinterStaff(source: DeletePrinterStaff): Promise<void> {
    return this.api.deletePrinterStaff(source)
  }
  async searchPrinterStaff(params: PrinterStaffSearchParams, page: number, perPage: number): Promise<PaginationResult<PrinterStaffSearchResult>> {
    return this.api.searchPrinterStaff(params, page, perPage)
  }
  async searchPrinterStaffFull(params: PrinterStaffSearchParams, page: number, perPage: number, options?: PrinterFetchOptions): Promise<PaginationResult<PrinterStaff>> {
    return this.api.searchPrinterStaffFull(params, page, perPage, options)
  }
  async getPrinterStaffCashDrawers(id: string, options?: CashDrawerFetchOptions): Promise<Array<CashDrawerStaff>> {
    return this.api.getPrinterStaffCashDrawers(id, options)
  }
  async hasPasswordStaff(printer: PrinterRef): Promise<boolean> {
    return this.api.hasPasswordStaff(printer)
  }
  async onlineStaff(printer: PrinterRef): Promise<boolean> {
    return this.api.onlineStaff(printer)
  }
  async pendingJobsStaff(printer: PrinterRef): Promise<number> {
    return this.api.pendingJobsStaff(printer)
  }
  async printReceiptStaff(request: PrinterPrintReceiptRequest): Promise<string> {
    return this.api.printReceiptStaff(request)
  }
  async printTestStaff(printer: PrinterRef): Promise<string> {
    return this.api.printTestStaff(printer)
  }
  async setCredentialsStaff(request: PrinterSetCredentialsRequest): Promise<void> {
    return this.api.setCredentialsStaff(request)
  }
}
